// extracted by mini-css-extract-plugin
export default {"active":"profile_active__A6+s3","default":"profile_default__JdeCV"};